import { render, staticRenderFns } from "./GrowthMarker.vue?vue&type=template&id=13d8cb5c&scoped=true&"
import script from "./GrowthMarker.vue?vue&type=script&lang=js&"
export * from "./GrowthMarker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13d8cb5c",
  null
  
)

export default component.exports